import { render, staticRenderFns } from "./HouseFundBrokerAccounts.vue?vue&type=template&id=9f0a9962&scoped=true&"
import script from "./HouseFundBrokerAccounts.vue?vue&type=script&lang=js&"
export * from "./HouseFundBrokerAccounts.vue?vue&type=script&lang=js&"
import style0 from "./HouseFundBrokerAccounts.vue?vue&type=style&index=0&id=9f0a9962&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0a9962",
  null
  
)

export default component.exports